<div id="serviceEcole-page">
    <div class="cover-photo" style="position: relative; z-index: 3; left: 0; right: 0; height: 200px;">
    </div>

    <div class="extra-light-grey-cfa-languedoc-bg" style="position: relative; z-index: 10;">

        <div class="container white-bg pt-3 px-1-on-small min-size">

            <div style="margin-left: -15px; margin-top: -110px !important; position: absolute; z-index: 12;">
                <h1 class="col-12 p-2 bandeau-title custom-background-color white font-weight-bold" style="display: table">Collèges et Lycées</h1>
                <h2 class="col-12 p-2 bandeau-subtitle grey-cfa-languedoc-bg white font-weight-bold">À vos côtés pour enrichir votre projet d’établissement</h2>
            </div>

            <div class="p-3 mt-4 px-0-on-small">

                <h1 style="font-size: 30px" class="col-12 blue-cfa-languedoc text-center">Prise de contact</h1>
                
                <div *ngIf="formAnswer && formAnswer.database">
                    <p class="mt-2">Votre demande a bien été prise en compte, nous vous en remercions.<br>
                    Vous serez prochainement contacté(e) par le Centre de Formation du Languedoc.<br>
                    D’ici là, nous restons à votre disposition au <a href="tel:0467527079">04 67 52 70 79</a> ou par mail à <a href="mailto:contact@apprentissage-montpellier.education">contact@apprentissage-montpellier.education</a></p>
                        
                    <div class="row" *ngIf="!isLoadingBrochures && brochure && brochure.b2b && brochure.b2b.length>0">
                        <p class="col-12 mb-0">Vous pouvez également télécharger les notices d’information à l’attention des établissements :</p>
                        <div *ngFor="let brochure of brochure.b2b" class="col-12 col-md-6 col-lg-4 mx-2">
                            <a [href]="'https://www.apprentissage-montpellier.education/brochures/' + brochure.lien_brochure" target="_blank">{{brochure.titre_produit}} - {{brochure.nom_instance}}</a>
                        </div>
                    </div>

                        
                </div>

                <div *ngIf="!formAnswer">
                    
                    <form>

                        <h5 class="col-12 form-title blue-bg mb-0 mt-4">Choix des services</h5>

                        <div class="py-1">
                            <div class="row px-5 py-1">
                                <div *ngIf="!isLoadingServicesEcolesDisponibles" class="col-12">
                                    <span>Choisissez les services qui vous intéressent</span>
                                </div>
                                <div class="col-6 col-md-4" *ngFor="let service of servicesEcolesDisponibles">
                                    <label (click)="onServiceClick($event)">
                                        <input type="checkbox" [name]="'service_'+ service.id_instance" [checked]="id_instance && id_instance == service.id_instance" [id]="'service_'+ service.id_instance" [value]="service.id_instance" (keydown.enter)="$event.preventDefault()">
                                        <span class="px-1" *ngIf="service.nom_instance && service.nom_instance !== ''">{{service.nom_instance}}</span>
                                    </label>
                                </div>
                                <div *ngIf="!isLoadingServicesEcolesDisponibles" class="col-12 small italic">
                                    <span>Nous vous enverrons des informations détaillées (modalités, fonctionnement, programme, profil des professeurs, tarifs, etc.)</span>
                                </div>

                                <div *ngIf="isLoadingServicesEcolesDisponibles" class="text-center m-0 p-0 col-sm-12">
                                    <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                                    <p>Chargement des services disponibles...</p>
                                </div>
                            </div>
                        </div>


                        <h5 class="col-12 form-title yellow-bg mb-0 mt-4">Établissement</h5>

                        <div class="py-1">
                            <div class="row px-5 py-1">
                                <div class="col-12 col-sm-8 col-md-6 col-lg-4">
                                    Code postal*
                                </div>
                                <div class="col-12 col-sm-4 col-md-6">
                                    <input class="yellow-border light-yellow-bg" size="5" type="text" [(ngModel)]="etablissementContactForm.codePostal" required (input)="verifCP($event) && onCodePostalBlur($event)" (keydown.enter)="$event.preventDefault()" name="ecole_cp" id="ecole_cp" maxlength="5">
                                </div>
                            </div>
        
                            <div class="row px-5 py-1">
                                <div class="col-12 col-sm-2 col-md-3 col-lg-2">
                                    Ville*
                                </div>
                                <div class="col-12 col-sm-10 col-md-9">
                                    <select name="ecole_ville" style="width: 100%" id="ecole_ville" class="yellow-border light-yellow-bg" [(ngModel)]="etablissementContactForm.ville" required (change)="onVilleChange($event)">
                                        <option [selected]="etablissementContactForm.ville == ''" value="">Entrez un code postal</option>
                                        <option *ngFor="let ville of villes">{{ville.nom}}</option>
                                    </select>                            
                                </div>
                            </div>
        
                            <div class="row px-5 py-1">
                                <div class="col-12 col-sm-4 col-md-3 col-lg-2">
                                    Établissement*
                                </div>
                                <div class="col-12 col-sm-8 col-md-6">    
                                    <select name="ecole_nom" id="ecole_nom" class="yellow-border light-yellow-bg" [(ngModel)]="etablissementContactForm.etablissement" required>
                                        <option [selected]="etablissementContactForm.etablissement == ''" value="">Choisissez une ville</option>
                                        <option *ngFor="let ecole of ecoles">{{ecole.nom}}</option>
                                    </select>                            
                                </div>
                            </div>
                        </div>


                        <h5 class="col-12 form-title green-bg mb-0 mt-4">Personne à contacter</h5>

                        <div class="py-1">
                            <div class="row px-5 py-1">
                                <div class="col-12 col-sm-3 col-md-3 col-lg-2">
                                    Nom*
                                </div>
                                <div class="col-12 col-sm-9 col-md-9">
                                    <input name="parent_nom" id="parent_nom" [(ngModel)]="etablissementContactForm.nomContact" maxlength="20" type="text" class="light-green-bg green-border" (blur)="verifNom($event)" required>
                                </div>
                            </div>

                            <div class="row px-5 py-1">
                                <div class="col-12 col-sm-3 col-md-3 col-lg-2">
                                    Fonction
                                </div>
                                <div class="col-12 col-sm-9 col-md-9">
                                    <input name="fonction" id="fonction" [(ngModel)]="etablissementContactForm.fonction" maxlength="60" type="text" class="light-green-bg green-border">
                                </div>
                            </div>

                            <div class="row px-5 py-1">
                                <div class="col-12 col-sm-3 col-md-3 col-lg-2">
                                    Téléphone*
                                </div>
                                <div class="col-12 col-sm-9 col-md-9">
                                    <input name="tel" id="tel" minlength="10" maxlength="15" [(ngModel)]="etablissementContactForm.telephone" type="text" class="light-green-bg green-border" required (blur)="verifTel($event)">
                                </div>
                            </div>

                            <div class="row px-5 py-1">
                                <div class="col-12 col-sm-3 col-md-3 col-lg-2">
                                    Mail*
                                </div>
                                <div class="col-12 col-sm-9 col-md-9">
                                    <input name="email" id="email" maxlength="20" [(ngModel)]="etablissementContactForm.mail" type="email" maxlength="40" class="light-green-bg green-border" (blur)="verifMail($event)" required>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="error" class="row px-5">
                            <p class="red-cfa-languedoc ml-auto pb-0 pt-1 mb-0">{{error}}</p>
                        </div>
                        <div *ngIf="isSendingForm" class="text-center">
                            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                            <span>Envoi du formulaire...</span>
                        </div>
                        <div id="submit" class="row px-5">
                            <div class="ml-auto">
                                <input name="envoie" type="button" (click)="verifForm()" value="Envoyer" class="blue-cfa-languedoc-bg bouton-submit col-xs-5 px-3 my-3">
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</div>